import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
const gameVuex = createNamespacedHelpers("game");
export default {
  name: "mLoading",
  computed: {
    ...gameVuex.mapState(["gameProgress"])
  },
  data() {
    const imgUrlArr = [require("@images/index-bg.jpg"), require("@images/guide/guide-img-botcode.jpg"), require("@images/guide/guide-img-slot.jpg"), require("@images/guide/guide-img-turn.jpg"), require("@images/guide/guide-icon-arrow.png"), require("@images/lucky-bg.jpg"), require("@images/machine/machine-page-bg.jpg"), require("@images/machine/machine-bg.png"), require("@images/machine/machine-main-bg.png"), require("@images/rewardAnim/anim-1.png"), require("@images/rewardAnim/anim-2.png"), require("@images/rewardAnim/anim-bg-COIN.png"), require("@images/machine/machine-btn1-bg.png"), require("@images/lucky-icon-mathine.jpg"), require("@images/lucky-icon-airdrop.jpg"), require("@images/COIN.png"), require("@images/LGCOIN.png"), require("@images/LGSPINS.png"), require("@images/SPINS.png"), require("@images/USDT.png"), require("@images/airdrop-box-img.png"), require("@images/firend-intro-bg.jpg"), require("@images/card-bg.png"), require("@images/reward-bg.jpg"), require("@images/PASS.png"), require("@images/upgrade-box.png"), require("@images/icon-gift-small.png"), require("@images/icon-lock-small.png"), require("@images/login-sign.jpg"), require("@images/buySpineItemBg1.png"), require("@images/buySpineItemBg2.png"), require("@images/buySpineItemBg3.png"), require("@images/buySpineItemBg2-tag.png"), require("@images/buySpineItemBg3-tag.png"), require("@images/lucky/lucky-bg.png"), require("@images/lucky/lucky-page-bg.jpg"), require("@images/lucky/lucky-8-item-1.png"), require("@images/lucky/lucky-8-item-2.png"), require("@images/lucky-icon-lucky.jpg"), require("@images/minibot/minibot-bg.jpg"), require("@images/minibot/minibot-store.png"), require("@images/minibot/minibot-store1.png"), require("@images/minibot/pet-bg.jpg"), require("@images/lucky-icon-minibot.jpg"), require("@images/pass/pass-bg.jpg"), require("@images/pass/pass-way-bg.jpg"), require("@images/avatar/pet/1.png"), require("@images/avatar/pet/2.png"), require("@images/avatar/pet/3.png"), require("@images/avatar/pet/4.png"), require("@images/avatar/pet/5.png"), require("@images/avatar/pet/6.png"), require("@images/botcode/game-icon-restart.png"), require("@images/botcode/game-item-bg.png"), require("@images/botcode/game-item-bg-icon.png"), require("@images/botcode/game-item-ok-bg.png"), require("@images/botcode/game-item-select-bg.png"), require("@images/botcode/option-bg.jpg"), require("@images/botcode/botcode-bg.jpg"), require(`@images/botcode/game-banner.jpg`), "https://static.humanpass.net/game/cipher/options/1.png", "https://static.humanpass.net/game/cipher/options/2.png", "https://static.humanpass.net/game/cipher/options/3.png", "https://static.humanpass.net/game/cipher/options/4.png", "https://static.humanpass.net/game/cipher/options/5.png", "https://static.humanpass.net/game/cipher/options/6.png", "https://static.humanpass.net/game/cipher/fails/1.png", "https://static.humanpass.net/game/cipher/fails/2.png", "https://static.humanpass.net/game/cipher/fails/3.png", "https://static.humanpass.net/game/cipher/fails/4.png", "https://static.humanpass.net/game/cipher/fails/5.png", "https://static.humanpass.net/game/cipher/fails/6.png"];
    return {
      backgroundImage: "",
      imgUrlArr,
      loadedCount: 0,
      show: true
    };
  },
  watch: {
    "gameProgress.currentLevel": {
      handler(val) {
        if (val > 0) {
          try {
            if (val >= this.botImgLimit) {
              this.imgUrlArr.push(require(`@images/avatar/body/${this.botImgLimit}.png`), require(`@images/avatar/head/${this.botImgLimit}.png`));
              return;
            }
            this.imgUrlArr.push(require(`@images/avatar/body/${val}.png`), require(`@images/avatar/head/${val}.png`));
            if (val < botImgLimit) {
              this.imgUrlArr.push(require(`@images/avatar/body/${val + 1}.png`), require(`@images/avatar/head/${val + 1}.png`));
            }
          } catch (err) {}
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    unorderedPreload() {
      this.$nextTick(() => {
        try {
          let backgroundImages = [];
          // 无序加载，并发下载图片
          this.imgUrlArr.forEach((imgUrl, i) => {
            var oImg = new Image();
            oImg.src = imgUrl;
            backgroundImages.push(`url(${imgUrl})`);
            oImg.addEventListener("load", this.imgLoaded);
            oImg.addEventListener("error", this.imgLoaded);
          });
          this.backgroundImage = backgroundImages.join(",");
        } catch (err) {}
      });
    },
    imgLoaded() {
      // 每次图片加载完成执行，无论成功或者失败
      this.loadedCount++;
      if (this.loadedCount >= this.imgUrlArr.length) {
        console.log("kkkkkkkkkkkk");
        // this.backgroundImage = ""
      }
    }
  },

  mounted() {
    this.unorderedPreload();
  }
};